module.exports = __webpack_public_path__ + "img/aboutUs_img1.01aacf7e.svg";